<div class="login-page">
  <div class="login-container">
    <!-- Left Panel - Branding -->
    <div class="login-branding">
      <div class="branding-content">
        <img src="Logo_QRserve.png" alt="QRServe" class="branding-logo">
        <h1 class="branding-title">QRServe</h1>
        <p class="branding-subtitle">Admin Dashboard</p>
        <div class="branding-features">
          <div class="feature-item">
            <i class="fas fa-chart-line"></i>
            <span>Real-time analytics</span>
          </div>
          <div class="feature-item">
            <i class="fas fa-users"></i>
            <span>Team management</span>
          </div>
          <div class="feature-item">
            <i class="fas fa-boxes"></i>
            <span>Inventory tracking</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Panel - Form -->
    <div class="login-form-panel">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-header">
          <h2 class="form-title">Welcome back</h2>
          <p class="form-subtitle">Sign in to your admin account</p>
        </div>

        <div class="form-group">
          <label for="email" class="form-label">Email address</label>
          <div class="input-wrapper">
            <i class="fas fa-envelope input-icon"></i>
            <input type="email"
                   id="email"
                   formControlName="email"
                   class="form-control"
                   placeholder="you@company.com">
          </div>
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <div class="input-wrapper">
            <i class="fas fa-lock input-icon"></i>
            <input type="password"
                   id="password"
                   formControlName="password"
                   class="form-control"
                   placeholder="Enter your password">
          </div>
        </div>

        <div class="form-options">
          <a [routerLink]="['/forgot-password']" class="forgot-link">Forgot password?</a>
        </div>

        <button type="submit"
                class="btn btn-primary btn-block submit-btn"
                [disabled]="loginForm.invalid || isLoading">
          @if (!isLoading) {
            Sign In
          } @else {
            <span class="spinner"></span>
            Signing in...
          }
        </button>
      </form>
    </div>
  </div>
</div>
